import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { XenaDSAccessor } from './xenads-accessor';

@Directive({
    selector: 'xena-switch, xena-checkbox',
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: XenaDSCheckboxValueAccessorDirective, multi: true }],
    standalone: false
})
export class XenaDSCheckboxValueAccessorDirective extends XenaDSAccessor implements ControlValueAccessor {
  constructor(element: ElementRef, renderer: Renderer2) {
    super(element, renderer, 'checked');
  }

  @HostListener('checkedChange', ['$event'])
  _handleValueChange(event: CustomEvent) {
    super._handleValueChange(event);
  }

  @HostListener('xnBlur')
  handleTouched() {
    if (this.onTouched) this.onTouched();
  }
}
